import { useState, useEffect } from "react";

// useState variant that persists to localStorage so the terminal remembers
// UI layout (collapsed cards, selected rows) between visits.
export function usePersistedState(key, initial) {
  const [state, setState] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw != null ? JSON.parse(raw) : initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch {
      /* ignore quota / private-mode errors */
    }
  }, [key, state]);

  return [state, setState];
}
